import React from "react";
import { RegisterRequest } from "../features";

function RegisterRequestPage() {
  return <RegisterRequest />;
}

export default RegisterRequestPage;
